const SidebarItems = [
  {
    menuTitle: "Dashboard",
    menuTextVariable: "homepage",
    visibility: false,
    iconName: "dashboard",
  },
  {
    menuTitle: "Announcements",
    menuTextVariable: "announcements",
    visibility: false,
    iconName: "announcement",
  },
  {
    menuTitle: "Journal",
    menuTextVariable: "journal",
    visibility: false,
    iconName: "journal",
  },
  {
    menuTitle: "Communication",
    menuTextVariable: "communication",
    visibility: false,
    iconName: "communication",
  },
  {
    menuTitle: "Bereavement Activity",
    menuTextVariable: "bereavement",
    visibility: false,
    iconName: "bereavement-activity",
  },
  {
    menuTitle: "Manage Invitations",
    menuTextVariable: "invite",
    visibility: false,
    iconName: "manage-invitation",
  },
  {
    menuTitle: "My Team",
    menuTextVariable: "workforce",
    visibility: false,
    iconName: "workforce",
  },
  {
    menuTitle: "Patients",
    menuTextVariable: "patient",
    visibility: false,
    iconName: "patients",
  },
  {
    menuTitle: "Form Summary",
    menuTextVariable: "forms-summary",
    visibility: false,
    iconName: "forms-summary",
  },
  {
    menuTitle: "Forms Designer",
    menuTextVariable: "form-builder",
    visibility: false,
    iconName: "forms",
  },
  {
    menuTitle: "Map",
    menuTextVariable: "map",
    visibility: false,
    iconName: "maps",
  },
  {
    menuTitle: "Smart Assiatant",
    menuTextVariable: "smart-assistant",
    visibility: false,
    iconName: "smart-assistant",
  },
  {
    menuTitle: "Chat Bot",
    menuTextVariable: "chat-bot",
    visibility: false,
    iconName: "chatbot",
  },
  {
    menuTitle: "Insights",
    menuTextVariable: "patient-insights",
    visibility: false,
    iconName: "insights",
  },
  {
    menuTitle: "Volunteers",
    menuTextVariable: "workforce-insights",
    visibility: false,
    iconName: "volunteers",
  },
  {
    menuTitle: "Census Risk View",
    menuTextVariable: "risk-view",
    visibility: false,
    iconName: "census-risk",
  },
  {
    menuTitle: "Reporting Dashboard",
    menuTextVariable: "reporting",
    visibility: false,
    iconName: "census-risk",
  },
  {
    menuTitle: "Audit Logs",
    menuTextVariable: "audit-logs",
    visibility: false,
    iconName: "audit-logs",
  },
  {
    menuTitle: "Audit Logs",
    menuTextVariable: "generic-audit-logs",
    visibility: false,
    iconName: "audit-logs",
  },
  {
    menuTitle: "Reporting Logs",
    menuTextVariable: "reporting-logs",
    visibility: false,
    iconName: "reporting-logs",
  },
  {
    menuTitle: "Billing",
    menuTextVariable: "billing",
    visibility: false,
    iconName: "billing",
  },
  {
    menuTitle: "Organizations",
    menuTextVariable: "organizations",
    visibility: false,
    iconName: "organizations",
  },
  {
    menuTitle: "Training",
    menuTextVariable: "training",
    visibility: false,
    iconName: "training",
  },
  {
    menuTitle: "Help Desk",
    menuTextVariable: "helpdesk",
    visibility: false,
    iconName: "helpdesk",
  },
  {
    menuTitle: "Sign Out",
    menuTextVariable: "logout",
    visibility: false,
    iconName: "sign-out",
  },
];

export default SidebarItems;
